module.exports = __webpack_public_path__ + "img/p4_4.d4f6f6f6.png";